import { toChartNumber } from '@/lib/chartUtils';
import { cn } from '@/lib/utils';

/** CSS bar ranking — avoids Recharts vertical-layout axis bugs with all-zero data. */
export default function TopTenantsBarList({ rows, className }) {
  if (!rows?.length) {
    return (
      <p className={cn('flex h-full items-center justify-center text-xs text-muted-foreground', className)}>
        No companies yet
      </p>
    );
  }

  const max = Math.max(...rows.map((r) => toChartNumber(r.sessions)), 1);

  return (
    <ul className={cn('flex h-full flex-col justify-center gap-2.5 py-1', className)}>
      {rows.map((row) => {
        const sessions = toChartNumber(row.sessions);
        const pct = Math.round((sessions / max) * 100);
        return (
          <li key={row.name} className="space-y-1">
            <div className="flex items-center justify-between gap-2 text-xs">
              <span className="min-w-0 truncate font-medium text-foreground" title={row.name}>
                {row.name}
              </span>
              <span className="shrink-0 font-mono tabular-nums text-foreground/65">{sessions}</span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-muted/60">
              <div
                className="h-full rounded-full bg-primary transition-[width] duration-500 ease-out"
                style={{ width: `${pct}%` }}
                role="presentation"
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
